import { Typography } from 'antd'
import { Fragment } from 'react'
import { useExternalLinkEditorContext } from './ExternalLinkEditorContext'
import { ExternalLinkEditorMessage } from '../types'

/** @private */
const ExternalLinkEditorMessages: React.FC = () => {
  const { messages } = useExternalLinkEditorContext()
  if (!messages) return null
  const text = Array<string>()
  if (messages.sharePoint) text.push(ExternalLinkEditorMessage.SharePoint)
  if (messages.editPackageNumberName)
    text.push(ExternalLinkEditorMessage.EditPackageNumberName)
  if (Array.isArray(messages.custom)) text.push(...messages.custom)
  else if (messages.custom) text.push(messages.custom)
  if (!text.length) return null
  return (
    <Fragment>
      {text.map((message, i) => (
        <Typography.Text key={i}>
          {message + (message.endsWith('.') ? '' : '.')}
        </Typography.Text>
      ))}
    </Fragment>
  )
}

export default ExternalLinkEditorMessages
